import React from "react";
import { Typography, Box, Grid, Chip } from "@mui/material";
import { IoGiftSharp } from "react-icons/io5";
import { MdSupportAgent, MdOutlineNotificationsActive } from "react-icons/md";
import {
  FaDollarSign,
  FaMagic,
  FaStethoscope,
  FaHandHoldingMedical,
  FaLaptopMedical,
  FaBriefcaseMedical,
  FaHandSparkles,
} from "react-icons/fa";

const icons1 = [
  <FaHandSparkles />,
  <FaHandHoldingMedical />,
  <FaMagic />,
  <FaLaptopMedical />,
  <IoGiftSharp />,
  <FaStethoscope />,
];

const icons2 = [
  <></>,
  <MdSupportAgent />,
  <MdOutlineNotificationsActive />,
  <Chip
    aria-label="cash rewards"
    className="chip"
    icon={
      <>
        <FaDollarSign className="primary" />
        <FaDollarSign className="primary" />
        <FaDollarSign className="primary" />
      </>
    }
    label={"Cash Rewards!"}
  />,
  <FaBriefcaseMedical />,
];

export default function InfoModule({ title, body, idx }) {
  return (
    <Grid container direction="row" justifyContent="space-around" alignItems="center">
      <Grid item xs={12} className="module" px={2} color="#1a237e">
        <div id={"module-" + (idx + 1).toString()}>
          <Typography variant="h3" component="div" lineHeight={1.1} color="#1a237e">
            {title}
          </Typography>
          {icons1[idx]}
          <Box
            fontWeight={300}
            color="#1a237e"
            dangerouslySetInnerHTML={{
              __html: body,
            }}
          />
          {icons2[idx]}
        </div>
      </Grid>
    </Grid>
  );
}
